import type { Grade } from '../types/api';
import { GRADE_LABEL, GRADE_TONE, baseGrade } from '../lib/grades';

/** Confidence grade pill. Always visible next to numbers (BR-001); overridden values carry a star (BR-005). */
export function GradeBadge({ grade, withLabel = false, title }: { grade: Grade | string; withLabel?: boolean; title?: string }) {
  const g = baseGrade(grade);
  const starred = String(grade).endsWith('*');
  const label = `${GRADE_LABEL[g]}${starred ? ' (overridden)' : ''}`;
  return (
    <span className="row" style={{ gap: 6, display: 'inline-flex' }} title={title ?? `Grade ${g}: ${label}`}>
      <span className={`grade ${GRADE_TONE[g]}`} aria-label={`Confidence grade ${g}${starred ? ', user override' : ''}`}>
        {g}{starred ? '*' : ''}
      </span>
      {withLabel && <span className="small muted">{label}</span>}
    </span>
  );
}
